<!-- SaveRowCell.vue -->
<template>
  <div class="text-center">
    <b-button
      v-if="row.isEdited"
      variant="success"
      class="p-1"
      size="sm"
      @click="$emit('save', row)"
    >
      <font-awesome-icon :icon="['fas', 'save']" /> Save
    </b-button>
  </div>
</template>

<script>
export default {
  props: ['row']
}
</script>
